/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { CommonService } from '../services/common.service';

@Component({
  selector: 'json-renderer',
  templateUrl: './json-renderer.component.html'
})
export class JsonRendererComponent implements ICellRendererAngularComp, OnDestroy {
  public params: any;
  public hasChallengeIconBadge: any = false;
  public challengeProgramCode = '';

  constructor(public commonService: CommonService) {}

  public agInit(params: any): void {
    this.params = params;
  }

  ngOnDestroy() {}

  public refresh(): boolean {
    return false;
  }
}
